import * as React from 'react';
import { Translate, I18n } from 'react-redux-i18n';

import Popup from '../../../Popup';
import { PopupBodyWrapper, Button } from './styles';

interface DeleteAllPopupProps {
	isDisplayed: boolean;
	onDeleteSequentially: () => void;
	onResetAll: () => void;
	onCancel: () => void;
	isProcessing?: boolean;
	label?: string;
	actionButtonColor?: string;
}

const DeleteAllPopup = ({
	isDisplayed,
	isProcessing,
	onDeleteSequentially,
	onResetAll,
	onCancel,
	label,
	actionButtonColor,
}: DeleteAllPopupProps) => (
	<Popup
		isDisplayed={isDisplayed}
		isLoading={isProcessing}
		label={label || I18n.t('messages.delete_data')}
		actionButtonColor={actionButtonColor}
		onCancel={onCancel}
	>
		<PopupBodyWrapper>
			<Button
				type="button"
				onClick={onDeleteSequentially}
			>
				<Translate value="messages.delete_assets_sequentially" />
			</Button>
			<Button
				type="button"
				onClick={onResetAll}
			>
				<Translate value="messages.reset_all_downloads" />
			</Button>
		</PopupBodyWrapper>
	</Popup>
);

export default DeleteAllPopup;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItem/DeleteButton/DeleteAllPopup/index.tsx